import React, { createRef } from "react";
import PopUpItem from "./../PopUp/PopUpItem";
import PopupArcode from "./../PopUp/PopUpArcode";
import PopUpOther, { CreditCode } from "./../PopUp/PopUpOther";
import { ReDate } from "./../PopUp/PopUpS_Cscustorder";
import { genpostURL, genURL, genpostURLTEST, genURLTEST } from "./../_getjson";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { parseJwt } from "../parseJWT";
import PopUpwarehouse from "./../PopUp/PopUpwarehouse";
import _group from "./../_source/groupConfig/_groupConfig";
import { Panel, Modal, ModalHeader, ModalBody, ModalFooter, Row, Grid, Col } from "react-bootstrap";
import Button from '@mui/material/Button';
import { checkData } from '../_source/checkDatainput'
import { checkunit } from '../_source/checkUnit'
import axios from 'axios'
import Backdrop from './../Components/CustomBackdrop/Barckdrop'
import Snackbar from './../Components/Snackbar/Snackbar'
import ErrorIcon from '@mui/icons-material/ErrorOutlineRounded';
import cheackprice from '../CustomFunction/Product/ChackPrice'
import CustomInput from "./../Components/CustomInput/Inputtext"
import SelectDatas from "./../PopUp/SelectData"
import MaterialUIPickers from "./../Components/CustomDatepicker/MaterialUIPickers"
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';
import FullScreenDialog from '../PopUp/FullScreendialogs/FullScreen'
import Topbar from "../Components/Customtopbar/Topbar";
import Checkstock from './../CustomFunction/Product/ChkStock'
import Rechecked from "./Components/Rechecked";
import Selectsaleref2 from "./Components/Selectsaleref2/Selectsaleref2";
import Repostview from "../Components/Reportview/Repostview";

const rowtable = 300;
const defaultcode = '0';
const listmenu = [["เอกสารอ้างอิงขาย", "saleRef2"]]
export default class PSSalesOrder extends React.Component {

  constructor(props) {
    super(props);
    this.CustomerCode = createRef();
    this.CustomerName = createRef();
    this.OrderNumber = createRef();
    this.Groupdata_code = createRef();
    this.Groupdata = createRef();
    this.CreditCode_code = createRef();
    this.CreditCode = createRef();
    this.SaleMan_code = createRef();
    this.SaleMan = createRef();
    this.SumPrice = createRef();
    this.TaxPersen = createRef();
    this.TaxPrice = createRef();
    this.valueTax = createRef();
    this.Department_code = createRef();
    this.Department = createRef();
    this.Discountinput = createRef();
    this.Discount = createRef();
    this.Branch_code = createRef();
    this.Branch = createRef();
    this.ProductValue = createRef();
    this.ValueExcept = createRef();
    this.pricetype = createRef();
    this.TotalPrice = createRef();
    this.REMARK = createRef();
    this.UserFieldsname = createRef();
    this.UserFieldslastname = createRef();
    this.UserFields3 = createRef();
    this.UserFields4 = createRef();
    this.UserFields5 = createRef();
    this.UserFields6 = createRef();
    this.state = {
      TBLastClick: -1,
      siteCodeUser: "",
      deprositState: 0,
      discount_s_row: "",
      discount_s_cellValue: "",
      value: { label: this.props.val, value: this.props.val },
      DOCGROUP_code: "",
      DOCGROUP_txt: "",
      Department_code: "",
      Department_txt: "",
      Branch_code: "",
      SiteCode_txt: "",
      show1: false,
      openBackdrop: false,
      autoClose: 3600,
      color: "warning",
      messagealert: "",
      PriceType_code: defaultcode,
      defaultselect: defaultcode,
      _hprefix: '',
      PROJECT: "",
      checkenableInput: { DocDate: 1 },
      defaultvaluewarehouse: "",
      defaultwarehouse: "",
      defaultlocation: "",
    };
  }
  handleChange(value) {
    this.setState({ value: value });
  }
  componentDidMount() {
    console.log("componentDidMount")
    //เช็คเปิดปิด textbox 
    this.setState({
      checkenableInput: JSON.parse(localStorage.getItem('checkoftxt'))
    })
    this.TaxPersen.current.value = parseFloat(7.0).toFixed(2);
    this.Discountinput.current.value = parseFloat(0).toFixed(2)
    this.setState({ _moto: _group["moto"] });
    this.setState({ _parts: _group["parts"] });

    // // console.log("----------------------------_group-------------------------");
    // // console.log(_group["moto"]);
    // // console.log("----------------------------_group-------------------------");
    let SITECODESTR = parseJwt(localStorage.getItem("Token"));
    // //console.log("22", SITECODESTR);
    this.setState({ siteCodeUser: SITECODESTR.User.SITECODE });
    this.setRow(rowtable);
    // /* console.log("222",rowtable); */
    this.onAddValue("SaleMan", SITECODESTR.User.CODE);
    if (localStorage.getItem("UsernameTH")) {
      this.SaleMan.current.value = localStorage.getItem("UsernameTH");
    }

    this._checkSitecode(SITECODESTR.User.SITECODE, "sitecode", "keypress");

    // // this.group("CSSALEORDER")
    // this.setState({ defaultwarehouse: SITECODESTR.User.SITECODE });
    // this.setState({ defaultlocation: SITECODESTR.User.SITECODE + "001" });

    let mid = new URLSearchParams(location.search).get("mid")
    this.loadFromInDB(mid)


  }


  saveData = () => {
    const parameter = new URLSearchParams();
    var dataTT = [];
    console.log("this.state.products[i].duedate");
    let s = [];
    for (var i = 0; i < this.state.products.length && this.state.products[i].productcode && typeof
      this.state.products[i].productcode !== undefined && this.state.products[i].productcode !== ""; i++) {
      console.log("this.state.products[i].duedate", this.state.products[i].duedate);
      /* console.log(this.state.products[i].stocktype); */
      if (this.state.products[i].stocktype === 0) {
        if (this.state.products[i].warehouse === "") {
          this.setState({ opensnackbar: true })
          this.setState({ color: "warning" })
          this.setState({ icon: ErrorIcon })
          this.setState({ messagealert: "กรุณาเลือกคลัง" })
          return;
        }
        if (this.state.products[i].location === "") {
          this.setState({ opensnackbar: true })
          this.setState({ color: "warning" })
          this.setState({ icon: ErrorIcon })
          this.setState({ messagealert: "กรุณาเลือกตำแหน่งเก็บ" })
          return;
        }
      }
      var duedate1 = ""
      console.log("this.state.products[i].duedate", this.state.products[i].duedate);
      if (typeof this.state.products[i].duedate !== "undefined") {
        var duedatesp = this.state.products[i].duedate.split('-')
        if (this.state.products[i].duedate) {
          duedate1 = duedatesp[2] + '/' + duedatesp[1] + '/' + (Number(duedatesp[0]) + 543)
        }
      }
      dataTT[i] = {
        Productcode: this.state.products[i].productcode,  //0
        Productname: this.state.products[i].productname,//1
        DeliDate: (this.state.products[i].DeliDate ? this.state.products[i].DeliDate : ""),//2
        Warehouse: this.state.products[i].warehouse,//3
        Location: this.state.products[i].location,//4
        Unitcode: this.state.products[i].unitcode,//5
        Quantity: this.state.products[i].quantity,//6
        Saleprice: this.state.products[i].saleprice,//7
        Discountword: this.state.products[i].discountword,//8
        Discountamount: this.state.products[i].discountamount,//9
        Amount: this.state.products[i].amount,//10
        Refer: (this.state.products[i].refer ? this.state.products[i].refer : "0"),//11
        Productgroup: (this.state.products[i].discountamount ? this.state.products[i].discountamount : "0"),//12
        Productgroup: this.state.products[i].productgroup,//13
        Duedate1: duedate1,//14
        Productset: this.state.products[i].productset,//15
        Parentcode: this.state.products[i].parentcode//16
      }
      s.push(dataTT[i]);
    }

    /* Success */
    parameter.append("listitem", JSON.stringify(s));
    parameter.append("DOCNO", this.OrderNumber.current.value);
    parameter.append("CREATEUSER", localStorage.getItem("Username"));
    parameter.append("REMARK", this.REMARK.current.value);
    parameter.append("ARCODE", this.CustomerCode.current.value);
    parameter.append("ARNAME", this.CustomerName.current.value);
    parameter.append("CREDITCODE", this.CreditCode_code.current.value);
    parameter.append("DOCGROUP", this.Groupdata_code.current.value);
    parameter.append("TAXTYPE", this.state.PriceType_code);
    parameter.append("DEPARTMENT", this.state.Department_code);
    parameter.append("SITECODE", this.state.Branch_code);
    parameter.append("SUMAMOUNT1", checkData("money", this.SumPrice.current.value));
    parameter.append("SUMAMOUNT2", checkData("money", this.ValueExcept.current.value));
    parameter.append("DISCWORD", checkData("text", this.Discount.current.value));
    parameter.append("DISCAMOUNT", checkData("money", this.Discountinput.current.value));
    parameter.append("AFTERDISC", this.ProductValue.current.value);
    parameter.append("TAXRATE", this.TaxPersen.current.value);
    parameter.append("TAXAMOUNT", this.TaxPrice.current.value);
    parameter.append("COMPUTERNAME", "");
    parameter.append("Name", this.UserFieldsname.current.value);
    parameter.append("LastName", this.UserFieldslastname.current.value);
    parameter.append("registration", this.UserFields3.current.value);
    parameter.append("Rn_regist", this.UserFields6.current.value);
    /* -------------------------------------------------------------- */
    parameter.append("DOCTYPE", this.state.DOCTYPE);
    parameter.append("Price", checkData("money", this.UserFields4.current.value));
    parameter.append("inter", checkData("money", this.UserFields5.current.value));
    parameter.append("BATHSUMAMOUNT2", checkData("money", this.ValueExcept.current.value));

    parameter.append("PROJECT", this.state.PROJECT);
    var Uststus = true;
    for (var pair of parameter.entries()) {
      console.log(pair);
      if (pair[0] === "ARCODE" && pair[1] === "") {
        Uststus = false;
        this.setState({ opensnackbar: true })
        this.setState({ color: "warning" })
        this.setState({ icon: ErrorIcon })
        this.setState({ messagealert: "กรุณากรอกรหัสลูกค้า" })
        return;
      } else if (pair[0] === "DOCGROUP" && pair[1] === "") {
        Uststus = false;
        this.setState({ opensnackbar: true })
        this.setState({ color: "warning" })
        this.setState({ icon: ErrorIcon })
        this.setState({ messagealert: "กรุณากรอกกลุ่มข้อมูล" })
        return;
      } else if (pair[0] === "DEPARTMENT" && pair[1] === "") {
        Uststus = false;
        this.setState({ opensnackbar: true })
        this.setState({ color: "warning" })
        this.setState({ icon: ErrorIcon })
        this.setState({ messagealert: "กรุณากรอกแผนก" })
        return;
      } else if (pair[0] === "PRODUCT" && pair[1] === "") {
        Uststus = false;
        this.setState({ opensnackbar: true })
        this.setState({ color: "warning" })
        this.setState({ icon: ErrorIcon })
        this.setState({ messagealert: "กรุณาเลือกสินค้า" })
        return;
      } else if (pair[0] === "UserFieldsname" && pair[1] === "") {
        Uststus = false;
        this.setState({ opensnackbar: true })
        this.setState({ color: "warning" })
        this.setState({ icon: ErrorIcon })
        this.setState({ messagealert: "กรุณากรอกชื่อลูกค้า" })
        return;
      } else if (pair[0] === "UserFieldslastname" && pair[1] === "") {
        Uststus = false;
        this.setState({ opensnackbar: true })
        this.setState({ color: "warning" })
        this.setState({ icon: ErrorIcon })
        this.setState({ messagealert: "กรุณากรอกนามสกุลลูกค้า" })
        return;
      }
    }
    if (Uststus === true) {
      // this.setState({ openBackdrop: true })
      //gengetURLTEST("http://Localhost:8080/save?l=0", parameter).then(res => {
      axios.post(genpostURL("CSSALEORDER/Save?user="), parameter).then((res) => {
        // axios.post(genpostURLTEST("/Save?l=0"), parameter).then((res) => {
        if (res.data.status === "success") {
          this.setState({ opensnackbar: true })
          this.setState({ color: "success" })
          this.setState({ icon: ErrorIcon })
          this.setState({ messagealert: "บันทึกสำเร็จ" })
          // setTimeout(() => {
          //   this.setState({ openBackdrop: false })
          //   this.ResetThisPage()
          // }, 30);

          setTimeout(() => {
            if (this.state.reporturl !== "") {
              this.setState({ openBackdrop: false })
              this._print(res.data.docno)
            } else {
              this.ReplacePage(window.location.pathname + location.search)
            }
          }, 30);

        } else {
          console.log(res.data);
          this.setState({ opensnackbar: true })
          this.setState({ color: "warning" })
          this.setState({ icon: ErrorIcon })
          this.setState({ messagealert: "บันทึกข้อมูลไม่สำเร็จ" })
          this.setState({ openBackdrop: false })
        }
      }).catch(error => {
        this.setState({ opensnackbar: true })
        this.setState({ color: "warning" })
        this.setState({ icon: ErrorIcon })
        this.setState({ messagealert: "เกิดข้อผิดพลาด" + error })
        this.setState({ openBackdrop: false })
      });
    }
  };

  loadFromInDB = async (mid) => { //โหลดฟอร์มสำหรับพิมพ์ใบเสร็จ
    //console.log("res.data", mid)
    let url = `reportmanage/reportform/${mid}?`
    console.log("loadFromInDB", genURL(url))
    let res = await axios.get(genURL(url))
    if (res.data.length > 0) {
      await this.setState({ reporturl: res.data[0].pathname })
      await this.setState({ formPrintdata: res.data })
    }
  }

  _print = (docno) => {
    try {
      if (formPrintdata.length > 1) {
        this.setState({ opensnackbar: true })
        this.setState({ color: "warning" })
        this.setState({ icon: ErrorIcon })
        this.setState({ messagealert: "กรุณาตรวจสอบลิงค์ From จำนวนลิงค์ฟอร์มมี " + formPrintdata.length })
        return;
      }
    } catch (error) {
    }
    if (this.state.reporturl !== "") {
      this.setState({
        openFullScreenDialog: true,
        typeFullScreenDialog: "Report",
        titleFullScreenDialog: "พิมพ์ใบบันทึกสั่งขาย",
        urlsend: `${process.env.REACT_APP_REPORTURL}${this.state.reporturl}&j_username=${process.env.REACT_APP_REPORTUSER}&j_password=${process.env.REACT_APP_REPORTPASSWORD}&output=${process.env.REACT_APP_REPORTTYPE}&api_key=${process.env.REACT_APP_REPORTAPIKEY}&docno=${docno}`
      });
      return
    } else {
      this.ResetThisPage("SAVE")
    }
  }

  ResetThisPage = (e) => {
    window.location.replace("/PSSalesOrder");
  };
  /*----------------------------------------------------------------------------------------------------------------------------*/
  SelectSetData = (data1, data2) => {
    switch (data1) {
      case "PriceType":
        this.setState({ PriceType_code: String(data2) })
        setTimeout(() => {
          this.ReLoadData()
        }, 500)
        break;
      case "_prefix":
        this.setState({ _hprefix: data2 })
        break;
      case "Calendar1":
        this.setState({ OrderDate1: data2 })
        break
      case "Calendar":
        this.setState({ OrderDate: data2 })
        break
      case "PROJECT":
        this.setState({ PROJECT: data2 })
        break
      default:
        break;
    }
  };
  confirm = () => {
    var col = this.state.products;
    for (var i = 0; i < col.length; i++) {
      if (col[i].productcode !== undefined) {
        this.setState({ show1: true })
      }
    }
  }
  Get_Arcode = async (event) => {
    if (event.key === "Enter") {
      // this.setState({ customer1: event.target.value })
      await this.GetArdata(event.target.value)
    }
  };

  GetArdata = async (arcode) => {
    this.setState({ openBackdrop: true })
    let url = "CSAR/ARCode?arcode=" + arcode + "&user=" + localStorage.getItem("Username");
    await axios.get(genURL(url), { timeout: 1800 }).then(res => {
      this.CustomerCode.current.value = "";
      this.CustomerName.current.value = "";
      if (res.data.length > 0) {
        for (let i = 0; i < res.data.length; i++) {
          this.CustomerCode.current.value = res.data[i].CODE;
          this.CustomerName.current.value = res.data[i].NAMETH;
          this.UserFieldsname.current.value = res.data[i].Arname;
          this.UserFieldslastname.current.value = res.data[i].Surname;
          this._pricetype(res.data[i].TAXTYPE);
          this.setState({ openBackdrop: false })
          if (arcode !== this.CustomerCode.current.value) {
            this.confirm()
          }
          setTimeout(() => {
            this.CreditCode_code.current.value = res.data[i].CREDITCODE;
            this.CreditCode.current.value = CreditCode(res.data[i].CREDITCODE);
            //TAXTYPE
          }, 30);
        }
      } else {
        this.setState({ openBackdrop: false })
        this.setState({ opensnackbar: true })
        this.setState({ color: "warning" })
        this.setState({ icon: ErrorIcon })
        this.setState({ messagealert: "ไม่พบข้อมูล" })
        this.CustomerCode.current.value = "";
        this.CustomerName.current.value = "";
      }
    }).catch(error => {
      this._chkload("Error" + error);
    }).finally(_ => {
      this.setState({ openBackdrop: false })
    });
  }
  Get_PopUparcode = (CustomerCode, CustomerName, Creditcode, Texttype, Address, _accountcdoe, _Prefix, _Arname, _Surname) => {
    this.CloseDialog(false)
    //console.log(_Arname, _Surname);
    // this.setState({ customer1: CustomerCode })
    this.CustomerCode.current.value = CustomerCode;
    this.CustomerName.current.value = CustomerName;
    //let result = CustomerName.split(" ")
    this.UserFieldsname.current.value = _Arname;
    this.UserFieldslastname.current.value = _Surname;
    //console.log("Texttype", Texttype) 
    setTimeout(() => {
      this._pricetype(Texttype);
      this.CreditCode_code.current.value = Creditcode;
      this.CreditCode.current.value = CreditCode(Creditcode);
      this.setState({ creditType: Creditcode });
      //TAXTYPE
    }, 30);
    this.confirm()
  };
  _pricetype = (Texttype) => {
    this.setState({ defaultselect: [Texttype] })
    this.setState({ PriceType_code: String(Texttype) });
    setTimeout(() => {
      this.Cal_Price();
    }, 500);
  };
  /* Setstate OnClick - OnBlur */
  Get_PopUpOther = (value) => {
    this.CloseDialog(false)
    var data = value.split("|");
    for (var i = 0; i < data.length; i++) {
      data[i] = data[i].trim();
    }
    switch (this.state.OtPopupType) {
      case "Groupdata":
        this.setState({ DOCGROUP_code: data[0] });
        this.setState({ DOCGROUP_txt: data[1] });
        this.onAddValue("Groupdata", data[0]);
        break;
      case "Department":
        /* OnClick */
        this.setState({ Department_code: data[0] });
        /* OnBlur */
        this.setState({ Department_txt: data[1] });
        /* this.Department_code.current.value = data[i]; */
        this.Department.current.value = data[1];
        break;
      case "CreditCode":
        this.CreditCode_code.current.value = data[0];
        this.CreditCode.current.value = data[1];
        break;
      case "Branch":
        /* OnClick */
        this.setState({ Branch_code: data[0] });
        /* OnBlur */
        this.setState({ SiteCode_txt: data[1] });
        /* this.Branch_code.current.value = data[i]; */
        this.Branch.current.value = data[1];
        break;
      default:
        break;
    }
  };
  Get_PopDocNoRef = (value) => {
    //console.log(value);
  };
  CalendarOnChange = (data, DateUp) => {
    var Backup = "";
    var today = new Date(data);
    if (DateUp) {
      today.setDate(today.getDate() + DateUp);
    }
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    today = dd + "/" + mm + "/" + (yyyy + 543);
    setTimeout(() => {
      Backup = this.state.MenuItem;
      this.setState({ MenuItem: "" });
    }, 0);
    setTimeout(() => {
      this.setState({ MenuItem: Backup });
    }, 10);
    return today;
  };
  /*------------------------------------------------center------------------------------------------------*/
  _cellButton(cell, row, enumObject, rowIndex) {
    var btn = this.state.products[rowIndex].btn1;
    var btnShow = "";
    switch (btn) {
      case 1:
        btnShow = (
          <div
            id={"Icon_row" + row.C0}
            style={{ cursor: "pointer", fontSize: "14px" }}
            onClick={() => this.Switch_PopUpItem("Search_Table")}
            onMouseDown={(e) => {
              this.setState({ TBLastClick: row.C0 });
            }}
          >
            <i className="fas fa-search" style={{ paddingTop: "7px" }}></i>
          </div>
        );
        break;
      case 2:
        btnShow = (
          <div id={"Icon_row" + row.C0} style={{ cursor: "pointer" }}>
            <i className="far fa-trash-alt" style={{ fontSize: "14px" }}></i>
          </div>
        );
        break;
      default:
        btnShow = (
          <i
            id={"Icon_row" + row.C0}
            style={{ fontSize: "10px", color: "#000" }}
          ></i>
        );
        break;
    }
    return <div>{btnShow}</div>;
  }
  _chkload = (cell, row, enumObject, rowIndex) => {
    return (
      <div>
        <i id={"load" + rowIndex}>{rowIndex + 1}</i>
      </div>
    );
  };
  _cellButton_btn_DeliDate = (cell, row, enumObject, rowIndex) => {
    var btn = this.state.products[rowIndex].btn_DeliDate1;
    var btnShow = "";
    switch (btn) {
      case 1:
        btnShow = (
          <div id={"Icon_row" + row.C0}
            style={{ cursor: "pointer", fontSize: "14px" }}
            onClick={() => this.Switch_PopUpwarehouse("setwarehousetable")}
            onMouseDown={(e) => {
              this.setState({ TBLastClick: row.C0 });
            }}
          >
            <i className="fas fa-search" style={{ paddingTop: "7px" }}></i>
          </div>
        );
        break;
      case 2:
        btnShow = (
          <div id={"Icon_row" + row.C0} style={{ cursor: "pointer" }}>
            <i className="far fa-trash-alt" style={{ fontSize: "14px" }}></i>
          </div>
        );
        break;
      default: btnShow = (
        <i
          id={"Icon_row" + row.C0}
          style={{ fontSize: "10px", color: "#000" }}
        ></i>
      );
        break;
    }
    return <div>{btnShow}</div>;
  };
  _cellButton_btn_DeliDate1 = (cell, row, enumObject, rowIndex) => {
    var btn = this.state.products[rowIndex].btn_DeliDate2;
    var btnShow = "";
    switch (btn) {
      case 1:
        btnShow = (
          <div
            id={"Icon_row" + row.C0}
            style={{ cursor: "pointer", fontSize: "14px" }}
            onClick={this.Switch_PopUpwarehouse.bind(null, "setwarehousetable")}
            onMouseDown={(e) => {
              this.setState({ TBLastClick: row.C0 });
            }}
          >
            <i className="fas fa-search" style={{ paddingTop: "7px" }}></i>
          </div>
        );
        break;
      case 2:
        btnShow = (
          <div id={"Icon_row" + row.C0} style={{ cursor: "pointer" }}>
            <i className="far fa-trash-alt" style={{ fontSize: "14px" }}></i>
          </div>
        );
        break;
      default:
        btnShow = (
          <i
            id={"Icon_row" + row.C0}
            style={{ fontSize: "10px", color: "#000" }}
          ></i>
        );
        break;
    }
    return <div>{btnShow}</div>;
  };
  setRow = (count) => {
    var data = [];
    for (var i = 0; i <= count - 1; i++) {
      data[i] = { C0: i + 1 };
    }
    this.setState({ products: data });
  };
  rowClassNameFormat = (row, rowIdx) => {
    return "";
  };

  onRowClick = (row, col, id) => {
    this.setState({ cellValue: row.productcode })
    this.setState({ id1: id });
    this.setState({ WHRow: id });
    var Pr = this.state.products;
    var j = rowtable;
    // ไม่ให้คีย์ข้ามแถว
    this.setState({ col1: false });
    this.setState({ col: false });
    // จำนวนเต็มเวลาคลิก
    let quantity = row.quantity, saleprice = row.saleprice;
    //console.log(col, row);
    if (col === 12 && quantity !== "" && quantity !== undefined) {
      row.quantity = parseFloat(quantity).toFixed(2)
    } else if (col === 13 && saleprice !== "" && saleprice !== undefined) {
      row.saleprice = parseFloat(saleprice).toFixed(2)
    }
    for (var i = 0; i < Pr.length; i++) {
      Pr[i].btn1 = 0;
      Pr[i].btn_DeliDate1 = 0;
      Pr[i].btn_DeliDate2 = 0;
    }
    // หาจากล่างขึ้นบน
    for (var i = this.state.products.length - 1; i >= 0; i--) {
      //หา แถวที่ว่างบนสุดใน products Table
      if (!this.state.products[i].productcode) {
        j = i;
      }
    }
    // BTN ค้นหาได้เฉพาะในแถว
    if ((col === 1 && j === id) || (col === 1 && Pr[id].productcode !== undefined)) {
      this.setState({ col1: true });
      Pr[id].btn1 = 1;
    } else if (col === 5 && row.productcode) {
      this.setState({ productcodeinrow: row.productcode });
      this.setState({ productcodeinrow1: row.warehouse });
      Pr[id].btn_DeliDate1 = 1;
    } else if (col === 7 && row.productcode) {
      this.setState({ productcodeinrow: row.productcode });
      this.setState({ productcodeinrow1: row.warehouse });
      Pr[id].btn_DeliDate2 = 1;
    }
    // ให้เพิ่มข้อมูลในแถวที่มีรหัสสินค้าได้
    if (typeof row.productcode !== "undefined" && row.productcode !== "") {
      this.setState({ col: true });
      // BTN วันที่
      Pr[id].btn_DeliDate = 1;
    }
    setTimeout(() => {
      this.setState({ products: Pr });
    }, 100);
  };

  /* ทำงานหละงจากมี action ในตาราง */
  onAfterSaveCell = async (row, cellName, cellValue) => {
    this.setState({ row: row.C0 - 1 })
    var cellValue1 = this.state.cellValue
    // ทศนิยม 2 ตำแหน่ง ปริมาณ  
    let quantity = row.quantity, saleprice = row.saleprice;
    if (cellName === "quantity" && quantity !== "") {
      // if (row.productset !== "1" && row.parentcode === "") {
      if (row.productcode !== "" && row.productset !== "1" && row.parentcode === "" && row.productgroup !== 3) { // เช็คสต๊อกสินค้า
        await Checkstock(row.productcode, "", row.unitcode, row.warehouse, row.location, row.productgroup, "saleorder").then(resstock => {
          console.log("resstock", resstock);
          if (Number(row.quantity) > Number(resstock)) {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: row.productcode + " จำกัดสินค้าไม่พอใช้งาน ในคลังมีจำนวน " + resstock + " " + row.unitname })
            if (resstock > 0) {
              row.quantity = parseFloat(resstock).toFixed(2)
            } else {
              row.quantity = "0"
            }
          }
        })
      } else if (cellName === "saleprice" && saleprice !== "") {
        row.saleprice = parseFloat(saleprice).toFixed(2)
        this.ReLoadData();
      }
    }
    if (cellName === "productcode" && cellValue !== "" && cellValue1 !== cellValue) {
      var col = this.state.products;
      col[row.C0 - 1] = [];
      col[row.C0 - 1].C0 = row.C0;
      col[row.C0 - 1].btn1 = row.btn1;
      this.setState({ products: col });
      this.AddDataTable(cellValue, row.C0 - 1, "", "");
    } else if (row.productcode === undefined || row.productcode === "") {
      setTimeout(() => {
        this.ReLoadData();
      }, 250);
    } else if ((cellName === "quantity" && cellValue !== "") || (cellName === "discountword" && cellValue !== "") || (cellName === "saleprice" && cellValue !== "")) {
      var col = this.state.products;
      this._chkGroup(col[row.C0 - 1].productcode, col[row.C0 - 1].C0);
      setTimeout(() => {
        let str = "" + cellValue;
        var res = str.match("%");
        if (res) {
          let newstr = str.split("%");
          if (newstr[0] * 1 > 100) {
            col[col[row.C0 - 1].C0 - 1].discountword = "100%";
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "สินค้ารหัส " + col[row.C0 - 1].productcode + "ส่วนลดใส่ได้ไม่เกิน 100% " })
          }
        } else {
          //console.log(str); 
        }
        setTimeout(() => {
          this.setState({ products: col });
        }, 100);
        setTimeout(() => {
          this.ReLoadData();
        }, 200);
      }, 300);
      setTimeout(() => {
        this.Cal_Price();
      }, 200);
    }
  };
  _chkGroup(val, row) {
    // เช็คกลุ่มสินค้า
    // console.log(this.state.codeGroup.substring(7, 8));
    try {
      var lastCode = this.state.codeGroup.substring(7, 8);
      this.setState({ lastCode_s_: lastCode });
    } catch (error) {
      this.setState({ lastCode_s_: 99 });
    }
    // console.log(lastCode);
    if (lastCode === 8) {
      let url =
        "CSPRODUCT/CHKGroup?code=" +
        val +
        "&user=" +
        localStorage.getItem("Username");
      // console.log(url);
      let loadname = "load" + row - 1;
      // var j = rowData;
      var col = this.state.products;
      axios.get(genURL(url), { timeout: 1800 }).then(res => {
        if (res.data.length > 0) {
          for (var i = 0; i < res.data.length; i++) {
            // console.log(res.data[i].MAINGROUP);
            this.setState({ groupNumber: res.data[i].MAINGROUP });
          }
        }
      });
    } else {
      this.setState({ groupNumber: 99 });
    }
  }
  Get_PopUpItem = (Code, data, stockCode) => {
    console.log("ssssss", data, stockCode)
    this.CloseDialog(false)
    this.AddDataTable(Code, this.state.TBLastClick - 1, data, stockCode);
  };
  AddDataTable = (ItemCode, row, data, stocktype) => {
    var col = this.state.products;
    for (var i = 0; i < col.length && col[i].productcode; i++) {
      if (col[i].productcode === ItemCode) {
        col[i].quantity = parseFloat(Number(col[i].quantity)).toFixed(2);
        this.setState({ products: col });
        this.ReLoadData();
        return;
      }
    }
    var url = "CSPRODUCT/GetAllProductcode?code=" + ItemCode + "&user=" + localStorage.getItem("Username");
    console.log("GetAllProductcode", genURL(url));
    axios.get(genURL(url)).then(async (ref) => {
      console.log("ref", ref.data);
      var j = 0;
      if (row > -1) {
        j = row;
      } else if (this.state.TBLastClick && this.state.TBLastClick > -1) {
        j = this.state.TBLastClick - 1;
      } else {
        for (var i = this.state.products.length - 1; i >= 0; i--) {
          // หาจากล่างขึ้นบน
          if (!this.state.products[i].productcode) {
            j = i;
          }
        }
      }
      if (ref.data.length > 0) {
        for (let index = 0; index < ref.data.length; index++) {
          let saleprice = 0
          let Discountword = 0;
          let MAINGROUP = "", STOCKTYPE = ""
          let NETSTOCK = 0
          let chk = true
          let stock = 0
          let chkLocation = ""
          let discountamount = 0;
          let productset = ""
          let parentcode = ""
          let amount = ""
          let defaultwarehouse = ""
          let defaultlocation = ""
          // let maxunit = "0"
          // console.log("PARENTCODE", ref.data[index].PARENTCODE, "ref.data[index].PRODUCTSET", ref.data[index].PRODUCTSET)
          try {
            parentcode = await typeof ref.data[index].PARENTCODE !== "undefined" ? ref.data[index].PARENTCODE : ""
          } catch (error) {
          }
          // warehouse = STOCKTYPE === 1 ? "" : this.state.defaultwarehouse
          // location = STOCKTYPE === 1 ? "" : this.state.defaultlocation
          defaultwarehouse = this.state.defaultwarehouse
          defaultlocation = this.state.defaultlocation
          if (parentcode === ""
            // && ref.data[index].PRODUCTSET !== 1
          ) {

            await cheackprice(ref.data[index].PRODUCTCODE, 1, this.CustomerCode.current.value, ref.data[index].UNITCODE, ref.data[index].ITEMTAXTYPE, this.state.DueDate, this.CreditCode_code.current.value).then((res) => {
              if (res !== undefined) {
                saleprice = parseFloat(res).toFixed(2)
              }
            }).catch((err) => {
              console.log("cheackprice err ", err);
              console.log(err);
            });
          } else if (ref.data[index].PRODUCTSET === 1) { // PRODUCTSET
            saleprice = ref.data[index].UNITPRICE === 0.00 ? "" : ref.data[index].UNITPRICE
            stock = ref.data[index].Quantity
            discountamount = saleprice
            amount = saleprice
            Discountword = saleprice
          } else { // รายการย่อยสินค้าชุด 
            try {
              saleprice = ref.data[index].AMOUNT
              Discountword = ref.data[index].DISCWORD
              stock = ref.data[index].QUANTITY
              discountamount = parseFloat(ref.data[index].DISCAMOUNT).toFixed(2)
              amount = ref.data[index].AMOUNT
            } catch (error) {
              console.log(`err${error}`);
            }
          }
          if (ref.data[index].PRODUCTSET !== 1) {
            let url1 = genURL("CSPRODUCT/Code?productset=" + ref.data[index].PRODUCTSET + "&stocktype=" + stocktype + "&code=" + ref.data[index].PRODUCTCODE)
            await axios.get(url1, { timeout: 3600 }).then(async (result) => {
              if (result.data.length > 0) {
                MAINGROUP = result.data[0].MAINGROUP == undefined ? "" : result.data[0].MAINGROUP
                STOCKTYPE = result.data[0].STOCKTYPE
                NETSTOCK = Number(result.data[0].NETSTOCK)
              }
            })
          }

          productset = parentcode !== "" && String(ref.data[index].PRODUCTSET) === "0" ? "2" : String(ref.data[index].PRODUCTSET)
          try {
            if (MAINGROUP === "01") {
              this.checkuserField(ref.data[index].PRODUCTCODE)
            }
          } catch (error) {
            // productset = String(ref.data[index].PRODUCTSET)
          }
          let unit = ""
          await checkunit(ref.data[index].UNITCODE).then(data => {
            unit = data
          })
          col[j] = {
            C0: j + 1,
            productcode: ref.data[index].PRODUCTCODE,
            btn1: col[0].btn1,
            productname: ref.data[index].PRODUCTNAME,
            warehouse: defaultwarehouse,
            location: defaultlocation,
            unitname: unit,
            unitcode: ref.data[index].UNITCODE,
            quantity: stock,
            saleprice: saleprice,
            discountword: Discountword,
            discountamount: discountamount,
            amount: amount,
            refdocno: "",
            stocktype: ref.data[index].STOCKTYPE,
            productgroup: Number(MAINGROUP),
            itemtaxtype: ref.data[index].ITEMTAXTYPE,
            productset: productset,
            parentcode: parentcode
          };
          j++
          await this.setState({ products: col });
          await this.setState({ openFullScreenDialog: false })
          await this.ReLoadData()
        }
      } else {
        // this.ReLoadData();
        this.setState({ opensnackbar: true })
        this.setState({ color: "warning" })
        this.setState({ icon: ErrorIcon })
        this.setState({ messagealert: "ไม่พบข้อมูลสินค้าในคลังสาขาของคุณ" })
      }
    })/*.catch((err) => {
      console.log(err);
    }); */
    setTimeout(() => {
      document.getElementById("TableLoadItem").innerHTML = "";
    }, 3000);
  };

  _chkDataimport = (val, row) => {
    // เช็คกลุ่มสินค้า
    let url =
      "CSPRODUCT/CHKGroup?code=" +
      val +
      "&user=" +
      localStorage.getItem("Username");
    // console.log(url);
    // var j = rowData;
    var col = this.state.products;
    axios.get(genURL(url), { timeout: 3600 }).then((res) => {
      if (res.data.length > 0) {
        for (var i = 0; i < res.data.length; i++) {
          //console.log(res.data[i].MAINGROUP);
          // this.setState({ groupNumber: res.data[i].MAINGROUP });
          col[row].productgroup = Number(res.data[i].MAINGROUP);
          col[row].productsubgroup = res.data[i].SUBGROUP1;
          col[row].stocktype = res.data[i].STOCKTYPE;
          col[row].unitcode = res.data[i].STOCKUNIT;
        }
      }
    });
    this.setState({ products: col });
    // } else {
    //     this.setState({ groupNumber: 99 });
    // }
  };

  // search ราคาขาย
  Cheackprice = async (productcode) => {
    let col = this.state.products;
    var data = ""
    // console.log("col", cheackprice(productcode, parseFloat(col[this.state.row].quantity).toFixed(0), this.CustomerCode.current.value.trim(), col[this.state.row].unitcode, this.state.PriceType_code, this.state.OrderDate));
    await cheackprice(productcode, parseFloat(col[this.state.row].quantity).toFixed(0), this.CustomerCode.current.value.trim(), col[this.state.row].unitcode, this.state.PriceType_code, this.state.OrderDate).then(async (res) => {
      if (res !== undefined) {
        data = await res
      }
    }).catch((err) => {
      console.log(err);
    });
    // But the best part is, we can just keep awaiting different stuff, without ugly .then()s
    // var somethingElse = await getSomethingElse()
    col[this.state.row].saleprice = parseFloat(data).toFixed(2)
    this.ReLoadData()

  }
  AddDataTable2 = async () => {
    var col = this.state.products;
    var data = "0.00"
    for (let i = 0; i < col.length; i++) {
      if (col[i].productcode !== undefined) {
        await cheackprice(col[i].productcode, parseFloat(col[i].quantity).toFixed(0), this.CustomerCode.current.value.trim(), col[i].unitcode, this.state.PriceType_code, this.state.OrderDate).then(async (res) => {
          if (res !== undefined) {
            data = await res
          }
        }).catch((err) => {
          console.log(err);
        });
        col[i].saleprice = parseFloat(data).toFixed(2) //cheackprice(col[i].productcode, parseFloat(col[i].quantity).toFixed(0), this.CustomerCode.current.value.trim(), col[i].unitcode, this.state.PriceType_code, this.state.OrderDate)
      }
    }
    this.setState({ products: col })
    this.ReLoadData()
  }

  // เรียงข้อมูลใหม่ ลบแถวที่ ไม่มีรหัสสินค้า แล้วเลื่อนขึ้นมา คำนวนราคา
  ReLoadData = (directions) => {
    var col = this.state.products;
    var NewCol = [];
    var j = 0;

    for (var i = 0; i < col.length; i++) {
      if (col[i].productcode) {
        NewCol[j] = col[i];
        NewCol[j].C0 = j + 1;
        NewCol[j].btn_DeliDate = 1;
        // แปลงหน่วย
        // col[j].unitname = checkInput("unitcode", col[i].unitcode)

        /*----------------------------------------------------คลัง-----*/
        if (col[i].warehouse === "" || col[i].location === "" || directions === "Y") {
          //  NewCol[j].warehouse = this.TreaSury.current.value;
          // NewCol[j].location = this.Storagelocation.current.value;
        }
        /*------------------------------------------------------------*/
        /* if (col[i].unitname === "-") {
          NewCol[j].discountword = col[i].saleprice * col[i].quantity;
        } */
        if (col[i].discountword === "-") {
          NewCol[j].discountword = col[i].saleprice * col[i].quantity;
        } else if (col[i].discountword === "") {
          NewCol[j].discountword = 0;
        } else if (col[i].discountword * 1 > col[i].saleprice * col[i].quantity * 1) {
          NewCol[j].discountword = col[i].saleprice * col[i].quantity;
        }

        let str = "" + NewCol[j].discountword;
        var res = str.match("%");
        if (res) {
          if (col[i].productcode !== "") {
            let newstr = str.split("%");

            NewCol[j].amount = parseFloat(col[i].saleprice * col[i].quantity - col[i].saleprice * col[i].quantity * (newstr[0] / 100)).toFixed(2);
            NewCol[j].discountamount = parseFloat(col[i].saleprice * col[i].quantity * (newstr[0] / 100)).toFixed(2);
          }
        } else {
          if (col[i].productcode !== "") {
            if (col[i].discountword * 1 > col[i].saleprice * col[i].quantity * 1) {
              NewCol[j].discountword = col[i].saleprice * col[i].quantity * 1;
            }
            let sum = col[i].saleprice * col[i].quantity * 1 - NewCol[j].discountword * 1;
            NewCol[j].quantity = parseFloat(NewCol[j].quantity).toFixed(2);
            NewCol[j].amount = sum.toFixed(2);
            NewCol[j].discountamount = parseFloat(NewCol[j].discountword).toFixed(2);
          }
        }
        j++;
      }
    }

    for (var i = j; i < col.length; i++) {
      NewCol[j] = { C0: j + 1 };
      j++;
    }
    setTimeout(() => {
      this.Cal_Price();
    }, 300);
    this.setState({ products: NewCol });
    /* this.Discountinput.current.value = ""; */
    this.Discount.current.value = parseFloat(0).toFixed(2);
  };



  /*------------------------------------------------------คำนวณยอดเงิน----------------------------------------------------------------------*/
  Cal_Price = (e) => {
    var SumPriceProduct = 0.0;
    var SumPriceProduct1 = 0.0
    var TaxPersen = Number(this.TaxPersen.current.value);
    var TaxPersen1 = 100 + TaxPersen;
    var DiscountPersen = Number(this.Discountinput.current.value)

    //console.log()
    for (var i = 0; i < this.state.products.length; i++) {
      if (this.state.products[i].amount && this.state.products[i].productset !== "2") {
        SumPriceProduct1 += parseFloat(this.state.products[i].amount)
        this.Discount.current.value = parseFloat((SumPriceProduct1 * DiscountPersen) / 100).toFixed(2)
        SumPriceProduct = SumPriceProduct1 - this.Discount.current.value
      }
    }
    // setTimeout(() => {
    this.setState({ allpriceforTax_: SumPriceProduct });
    // }, 300);
    // var Discountinput = 0;
    // if (this.Discountinput.current.value) { Discountinput = parseFloat(this.Discountinput.current.value).toFixed(2); }
    // this.Discountinput.current.value = parseFloat(Discountinput).toFixed(2);

    var Discount = 0;
    if (this.Discount.current.value) {
      Discount = parseFloat(this.Discount.current.value).toFixed(2);
    }
    this.Discount.current.value = parseFloat(Discount).toFixed(2);
    /* if (this.TaxPersen.current.value) {
      TaxPersen = parseFloat(TaxPersen).toFixed(2);
    } */
    this.Discountinput.current.value = parseFloat(DiscountPersen).toFixed(2)
    this.TaxPersen.current.value = parseFloat(TaxPersen).toFixed(2);
    //--------------------------------------เช็คประเภทภาษี------------------------------------------
    if (this.state.PriceType_code === "0") {
      //ไม่รวมภาษี
      this.ProductValue.current.value = parseFloat(SumPriceProduct).toFixed(2);
      // ภาษีมูลค่าเพิ่ม
      this.TaxPrice.current.value = parseFloat(
        (SumPriceProduct * 7) / 100
      ).toFixed(2);
      this.SumPrice.current.value = parseFloat(SumPriceProduct).toFixed(2);
      this.TotalPrice.current.value = parseFloat(
        (SumPriceProduct * 7) / 100 + SumPriceProduct
      ).toFixed(2);
      this.valueTax.current.value = parseFloat(
        (SumPriceProduct * 7) / 100 + SumPriceProduct
      ).toFixed(2);
      this.ValueExcept.current.value = "0.00"
    } else if (this.state.PriceType_code === "1") {
      //รวมภาษี
      // ภาษีมูลค่าเพิ่ม
      this.TaxPrice.current.value = parseFloat((SumPriceProduct * TaxPersen) / TaxPersen1).toFixed(2);
      this.ProductValue.current.value = parseFloat(
        SumPriceProduct - Number(this.TaxPrice.current.value)
      ).toFixed(2);
      this.SumPrice.current.value = SumPriceProduct.toFixed(2);
      this.TotalPrice.current.value = SumPriceProduct.toFixed(2);
      this.valueTax.current.value = SumPriceProduct.toFixed(2);
      this.TaxPrice.current.value = parseFloat((SumPriceProduct - Number(this.ProductValue.current.value))).toFixed(2);
      this.ValueExcept.current.value = "0.00"
    } else {
      this.ProductValue.current.value = parseFloat(SumPriceProduct).toFixed(2);
      // ภาษีมูลค่าเพิ่ม
      this.TaxPrice.current.value = "0.00"; /* parseFloat((SumPriceProduct * TaxPersen) / 100).toFixed(2); */
      this.SumPrice.current.value = SumPriceProduct.toFixed(2);
      this.TotalPrice.current.value = SumPriceProduct.toFixed(2);
      this.valueTax.current.value = SumPriceProduct.toFixed(2);
      this.ValueExcept.current.value = "0.00"
    }
    var ValueExcept = 0;
    if (this.ValueExcept.current.value) {
      ValueExcept = parseFloat(this.ValueExcept.current.value).toFixed(2);
    }
  };

  Cal_Price1 = (e) => {
    if (e.key === "Enter" && e.target.value !== "") {
      this.Cal_Price();
    }
  }
  /*-------------------------------------------popup------------------------------------------------------------------------------*/

  Switch_PopupArcode = (e) => {
    //ชื่อ
    this.setState({ typeFullScreenDialog: e })
    //open
    this.setState({ openFullScreenDialog: true })
    //title
    this.setState({ titleFullScreenDialog: "ค้นหาลูกค้า-AR" })
  };
  Switch_OtherPopup = (e) => {
    //ชื่อ
    this.setState({ OtPopupType: e })
    //ชื่อ
    this.setState({ typeFullScreenDialog: e })
    //open
    this.setState({ openFullScreenDialog: true })
    if (e === "Groupdata") {
      this.setState({ titleFullScreenDialog: "เลือกรายการ-csdocgroup" })
    }
    if (e === "Department") {
      this.setState({ titleFullScreenDialog: "เลือกรายการ-csdepartment" })
    }
    if (e === "Branch") {
      this.setState({ titleFullScreenDialog: "เลือกรายการ-cssite" })
    }
    if (e === "CreditCode") {
      this.setState({ titleFullScreenDialog: "เลือกรายการ-creditcode" })
    }
  };
  /*--------------------------------------------------------พิเศษ------------------------------------------------------------*/
  SwitchValue = (ref, type) => {
    //console.log("switchvalue");
    if (type === "EnterEvent") {
      var M_data = this[ref].current.value;
      var D_data = this[ref + "_code"].current.value;
      this[ref].current.value = D_data;
      this[ref + "_code"].current.value = M_data;
    } else {
      if ((type === "IN" && this.state.LastRef !== ref) || type === "OUT") {
        var M_data = this[ref].current.value;
        var D_data = this[ref + "_code"].current.value;
        this[ref].current.value = D_data;
        this[ref + "_code"].current.value = M_data;
        this.setState({ LastRef: ref });
      }
      if (type === "OUT" && this.state.LastRef === ref) {
        this.onAddValue(ref, M_data);
        this.setState({ LastRef: "" });
      }
    }
  };
  onChangeData = (e, val) => {
    var Ref = this.state.LastRef;
    if (e.key === "Enter") {
      this.onAddValue(Ref, val).then((res) => {
        this.SwitchValue(Ref, "EnterEvent");
      });
    }
  };
  onAddValue = async (type, value) => {
    if (value) {
      var Url = "";
      switch (type) {
        case "Groupdata1":
          Url =
            "CSDOCGROUP/Code?tablename=CSSALEORDER&code=" +
            value +
            "&user=" +
            localStorage.getItem("Username") +
            "&top=30";
          axios.get(genURL(Url)).then((res) => {
            if (res.data.length === 1) {
              for (let i = 0; i < res.data.length; i++) {
                this.Groupdata.current.value = res.data[i].MYNAMETH;
                this.setState({ DOCGROUP_txt: res.data[i].MYNAMETH });
                this.Groupdata_code.current.value = res.data[i].CODE;
              }
            } else {
              this.Groupdata.current.value = "";
              this.Groupdata_code.current.value = "";
            }
            return "SS";
          });
          break;
        case "Groupdata":
          Url = "CSDOCGROUP/Code?tablename=CSSALEORDER&code=" + value + "&user=" + localStorage.getItem("Username") + "&top=30";
          axios.get(genURL(Url), { timeout: 3600 }).then((res) => {
            if (res.data.length === 1) {
              let CODE
              for (let index = 0; index < res.data.length; index++) {
                this.Groupdata.current.value = res.data[index].MYNAMETH;
                this.setState({ DOCGROUP_txt: res.data[index].MYNAMETH });
                this.Groupdata_code.current.value = res.data[index].CODE;
                this.onAddValue("Branch", res.data[index].SITECODE);
                // console.log("xxxxxxxxxxxxxxxxxxxxxx" + res.data[i].CODE);
                this.TaxPersen.current.value = res.data[index].TAXRATE;
                setTimeout(() => {
                  if (res.data[index].TAXRATE === "0.00") {
                    this.TaxPrice.current.value = 0.0;
                    this._pricetype("2");
                    // setTimeout(() => {
                    this.Cal_Price();
                    // }, 100);
                  }
                }, 20);
                this.setState({ codeGroup: res.data[index].CODE });
                this.ReLoadData();
                CODE = res.data[index].CODE.trim();
              }
              var Url = "CSMAXDOC/MAXDOC?tablename=CSSALEORDER&code=" + CODE;
              axios.get(genURL(Url), { timeout: 3600 }).then((res) => {
                //  console.log(res.data);
                if (res.data) {
                  this.OrderNumber.current.value = res.data["maxdoc"];
                }
                var type = this.OrderNumber.current.value.substring(0, 2);
                //console.log(type);
                if (type === "SO") {
                  this.setState({ DOCTYPE: 0 });
                } else {
                  this.setState({ DOCTYPE: 1 });
                }
              });
            } else {
              this[type].current.value = "";
              this[type + "_code"].current.value = "";
            }
            return "SS";
          });
          break;
        case "SaleMan":
          Url = "CSUSER/Chkuser?code=" + value + "&user=";

          let result = await axios.get(genURL(Url)).then((res) => {
            return res.data
          });

          if (result.length > 0) {

            this.SaleMan.current.value = result[0].MYNAMETH;
            this.SaleMan_code.current.value = result[0].CODE;
          }
          else {
            this.SaleMan.current.value = "";
            this.SaleMan_code.current.value = "";
          }
          break;
        case "Department":
          Url =
            "CSDEPARTMENT/ByCode?code=" +
            value +
            "&user=" +
            localStorage.getItem("Username");
          axios.get(genURL(Url), { timeout: 3600 }).then((res) => {
            if (res.data.length === 1) {
              for (let i = 0; i < res.data.length; i++) {
                this[type].current.value = res.data[i].MYNAMETH;
                this.setState({ Department_txt: res.data[i].MYNAMETH });
                this[type + "_code"].current.value = res.data[i].CODE;
              }
            } else {
              this[type].current.value = "";
              this[type + "_code"].current.value = "";
            }
            return "SS";
          });
          break;
        case "Branch":
          Url =
            "CSSITE/Getsite?Code=" +
            value +
            "&user=" +
            localStorage.getItem("Username");
          //console.log(genURL(Url));
          axios.get(genURL(Url), { timeout: 3600 }).then((res) => {
            if (res.data.length === 1) {
              for (let i = 0; i < res.data.length; i++) {
                this[type].current.value = res.data[i].MYNAMETH;
                this.setState({ SiteCode_txt: res.data[i].MYNAMETH });
                this[type + "_code"].current.value = res.data[i].CODE;
              }
            } else {
              this[type].current.value = "";
              this[type + "_code"].current.value = "";
            }
            return "SS";
          });
          break;
        default:
          break;
      }
    }
  };

  ///-------------------------------------save data --------------------------
  _connectsaveData = () => {
    var tabaldata = this.state.products;
    for (let index = 0; index < tabaldata.length; index++) {
      if (typeof tabaldata[index].productcode !== "undefined") { // เช็ค productcode

        if (typeof tabaldata[index].group !== "undefined" && Number(tabaldata[index].productgroup) !== 3 && (typeof tabaldata[index].location === "undefined" || tabaldata[index].location === "")) {
          this.setState({ opensnackbar: true })
          this.setState({ color: "warning" })
          this.setState({ icon: ErrorIcon })
          this.setState({ messagealert: "กรุณาตรวจสอบที่เก็บของสินค้าของคุณ" })
          return;
        }
        /* console.log(tabaldata[index].productcode + "::::" + tabaldata[index].saleprice + ":::" + index); */
        if (Number(tabaldata[index].saleprice) === 0 && (Number(tabaldata[index].productgroup) !== 3) && Number(tabaldata[index].productgroup) !== 0) {
          this.setState({ opensnackbar: true })
          this.setState({ color: "warning" })
          this.setState({ icon: ErrorIcon })
          this.setState({ messagealert: `กรุณากำหนดราคาขายของสินค้ารหัส ${tabaldata[index].productcode} ` })
          return;
        }
        if (((typeof tabaldata[index].quantity !== "undefined") && (Number(tabaldata[index].quantity) === 0) && (Number(tabaldata[index].productgroup) !== 3 && Number(tabaldata[index].productgroup) !== 0))) {
          this.setState({ opensnackbar: true })
          this.setState({ color: "warning" })
          this.setState({ icon: ErrorIcon })
          this.setState({ messagealert: `ปริมาณสินค้ารหัส ${tabaldata[index].productcode} ต้องไม่เท่ากับ ${tabaldata[index].quantity} ` })
          return
        }
      }// end if เช็ค productcode
      // console.log("zzzz", Number(this.state.tabaldata[i].quantity))
    }// end for
    switch (this.state.creditType) {
      default:
        this.saveData();
        break;
    }
  };
  Switch_PopUpItem = (e) => {
    this.setState({ typeFullScreenDialog: e })
    //open
    this.setState({ openFullScreenDialog: true })
    //title
    this.setState({ titleFullScreenDialog: "ค้นหาสินค้า-product" })
  };
  /* Click */
  ClickDocGroupcode = () => {
    //console.log("DOCGROUP_code", this.state.DOCGROUP_code);
    this.setState({ Groupdata: this.state.DOCGROUP_code });
    this.Groupdata.current.value = this.state.DOCGROUP_code;
  };
  ClickDepartmentCode = () => {
    this.setState({ Department: this.state.Department_code });
    this.Department.current.value = this.state.Department_code;
  };
  ClickSiteCode = () => {
    this.setState({ Branch: this.state.Branch_code });
    this.Branch.current.value = this.state.Branch_code;
  };
  Onblur = (e) => {
    switch (e.target.name) {
      case 'Department':
        if (e.target.value === "") {
          this.Groupdata.current.value = "";
          this.state.Department_txt = "";
          this.state.Department_code = "";
        }
        break;
      case 'SiteCode':
        if (e.target.value === "") {
          this.Branch.current.value = "";
          this.state.SiteCode_txt = "";
          this.state.Branch_code = "";
        }
        break;
      case 'Groupdata':
        if (e.target.value === "") {
          this.Groupdata.current.value = "";
          this.OrderNumber.current.value = "";
          this.state.DOCGROUP_code = "";
          this.state.DOCGROUP_txt = "";
        }
        break;
      case 'CustomerCode':
        if (e.target.value === "") {
          this.CustomerCode.current.value = "";
          this.CustomerName.current.value = "";
        }
        break;

      default:
        break;
    }
  }
  onBlur = (e) => {
    /* กลุ่มข้อมูล */
    this.setState({ Groupdata: this.state.DOCGROUP_txt });
    this.Groupdata.current.value = this.state.DOCGROUP_txt;
    /* แผนก */
    this.setState({ Department: this.state.Department_txt });
    this.Department.current.value = this.state.Department_txt;
    /* สาขา */
    this.setState({ SiteCode_txt: this.state.SiteCode_txt });
    this.Branch.current.value = this.state.SiteCode_txt;

    // if (e.target.name === "OrderDate1") {
    //   if (e.target.value !== "") {
    //     this.state.OrderDate1 = cheackdate(this.state.OrderDate1)
    //     setTimeout(() => {
    //       if (cheackdate(this.state.OrderDate1) === "") {
    //         this.OrderDate1.current.focus()
    //         this.setState({ opensnackbar: true })
    //         this.setState({ color: "warning" })
    //         this.setState({ icon: ErrorIcon })
    //         this.setState({ messagealert: "รูปแบบวันที่ไม่ถูกต้อง" })
    //       }
    //     }, 500);
    //   }
    // }

  };
  /* เช็คข้อมูลตรงกับตารางหรือไม่ตรง */
  onClickDocNo = async () => {
    if (!this.state.DOCGROUP_code) {
      this.setState({ opensnackbar: true })
      this.setState({ color: "warning" })
      this.setState({ icon: ErrorIcon })
      this.setState({ messagealert: "ไม่พบข้อมูล" })
      // this.dialog.showAlert('กรุณาเลือกกลุ่มข้อมูล');   return;
    }
    if (this.state.DOCGROUP_code) {
      var Url = "CSMAXDOC/MAXDOC?tablename=CSSALEORDER&code=" + this.state.DOCGROUP_code.trim();
      axios.get(genURL(Url), { timeout: 3600 }).then((res) => {
        //console.log("====================================");
        //console.log(res.data.maxdoc);
        //console.log("====================================");
        if (res.data.maxdoc.length > 0) {
          this.OrderNumber.current.value = res.data.maxdoc;
        } else {
          this.OrderNumber.current.value = "";
        }
      }).catch(error => {
        this._chkload("Error" + error);
      });
    } else {
      this.OrderNumber.current.value = "";
    }
  };
  /* Enter */
  _checkSitecode = async (val, tagID, source) => {
    let Url = "CSSITE/Getsite?Code=" + val + "&user=" + localStorage.getItem("Username");
    await axios.get(genURL(Url), { timeout: 1800 }).then((res) => {
      switch (source) {
        case "keypress":
          if (res.data.length > 0) {
            for (let i = 0; i < res.data.length; i++) {
              /* SetOnClick */
              this.setState({ SiteCode_txt: res.data[i].MYNAMETH });
              /* SetOnblur */
              this.setState({ Branch_code: res.data[i].CODE });
              this.Branch.current.value = res.data[i].MYNAMETH;
              this.setState({ openBackdrop: false })
            }
          } else {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "ไม่พบข้อมูล" })
            this.setState({ SiteCode_txt: "" });
            this.setState({ SiteCode_code: "" });
            this.Branch.current.value = "";
            this.setState({ openBackdrop: false })
          }
          break;
        case "intable":
          if (res.data.length === 1) {
            for (let index = 0; index < res.data.length; index++) {
              this.setState({ C_TSitecode: res.data[index].CODE });
              this.setState({ T_Sitecode: res.data[index].MYNAMETH });

            }
            this.setState({ openBackdrop: false })

          } else {
            this.setState({ C_TSitecode: "" });
            this.setState({ T_Sitecode: "" });
            this.setState({ openBackdrop: false })
          }
          break;
        default:

          break;
      }
    }).catch(error => {
      this._chkload("Error" + error);
      this.setState({ openBackdrop: false })
    });
  };
  _checkDocgroup = (val, tagID, source) => {
    var Url = "CSDOCGROUP/Code?tablename=CSSALEORDER&code=" + val;
    axios.get(genURL(Url), { timeout: 1800 }).then((res) => {
      switch (source) {
        case "input":
          if (res.data.length === 1) {
            for (let index = 0; index < res.data.length; index++) {
              this.TaxPersen.current.value = res.data[index].TAXRATE
              this.setState({ DOCGROUP_txt: res.data[index].MYNAMETH });
              this.setState({ DOCGROUP_code: res.data[index].CODE });
              this.Groupdata.current.value = res.data[index].MYNAMETH;
            }
            this.onClickDocNo();
            this.setState({ openBackdrop: false })
          } else {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "ไม่พบข้อมูล" })
            this.setState({ DOCGROUP_txt: "" });
            this.setState({ DOCGROUP_code: "" });
            this.Groupdata.current.value = "";
            this.setState({ openBackdrop: false })
            this.OrderNumber.current.value = "";
          }
          break;
        case "rechk":
          if (res.data.length === 1) {
            for (let index = 0; index < res.data.length; index++) {
              this.setState({ DOCGROUP_txt: res.data[index].MYNAMETH });
              this.setState({ DOCGROUP_code: res.data[index].CODE });
              this.Groupdata.current.value = res.data[index].MYNAMETH;
            }
          } else {
            this.setState({ DOCGROUP_txt: "" });
            this.setState({ DOCGROUP_code: "" });
            this.Groupdata.current.value = "";
          }
          break;
        default:
          break;
      }
    }).catch(error => {
      this._chkload("Error" + error);
      this.setState({ openBackdrop: false })
    });
  };
  _checkDepartmant = (val, tagID, source) => {
    var Url = "CSDEPARTMENT/ByCode?code=" + val + "&user=" + localStorage.getItem("Username");
    axios.get(genURL(Url), { timeout: 1800 }).then((res) => {
      switch (source) {
        case "input":
          if (res.data.length > 0) {
            for (let index = 0; index < res.data.length; index++) {
              this.setState({ Department_txt: res.data[index].MYNAMETH });
              this.setState({ Department_code: res.data[index].CODE });
              this.setState({ Department: res.data[index].MYNAMETH });
              this.Department.current.value = res.data[index].MYNAMETH;
            }
            this.setState({ openBackdrop: false })
          } else {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "ไม่พบข้อมูล" })
            this.setState({ Department_txt: "" });
            this.setState({ Department_code: "" });
            this.Department.current.value = "";
            this.setState({ openBackdrop: false })
          }
          break;
        case "intable":
          if (res.data.length === 1) {
            for (let index = 0; index < res.data.length; index++) {
              this.setState({ C_TDepartment: res.data[index].CODE });
              this.setState({ T_Department: res.data[index].MYNAMETH });
            }
            this.setState({ openBackdrop: false })
          } else {
            this.setState({ C_TDepartment: "" });
            this.setState({ T_Department: "" });
            this.setState({ openBackdrop: false })
          }
          break;
        case "inrow":
          if (res.data.length === 1) {
            this.setState({ openBackdrop: false })
            let rs
            for (let index = 0; index < res.data.length; index++) {
              rs = res.data[index].MYNAMETH;
            }
            return rs
          } else {
            this.setState({ openBackdrop: false })
          }
          break;
        default:
          break;
      }
    }).catch(error => {
      this._chkload("Error" + error);
      this.setState({ openBackdrop: false })
    });
  };
  onKeyPress = (e) => {
    if (e.key === "Enter") {
      if (e.target.name === "SiteCode") {
        this._checkSitecode(e.target.value, "sitecode", "keypress");
      } else if (e.target.name === "Groupdata") {
        this._checkDocgroup(e.target.value, "Docgroup", "input");
      } else if (e.target.name === "Department") {
        this._checkDepartmant(e.target.value, "CSDEPARTMENT", "input");
      }
    }
  };

  //------------------------------- คำนวนส่วนลดรวม--------------------------------------
  _calculatdiscount = () => {
    if (this.Discountinput.current.value === "") {
      this.ReLoadData();
      // this.Discountinput.current.value=parseFloat(0).toFixed(2);
      this.Discount.current.value = parseFloat(0).toFixed(2);
      this.Discountinput.current.value = "";
      //   this.setState({ allpriceforTax_: this.SumPrice.current.value});// เอาไว้ใช้คำนวนเบี้ยใหม่
      // setTimeout(() => {
      // }, 100);
    } else {
      // -----------------------------ส่วนลด-------------------------------------------------------
      let chkper_;
      let str = this.Discountinput.current.value;
      var res = String(str.match("%"));
      if (res === "%") {
        var inputsprit = str.replace("%", "");
        // console.log(inputsprit);
        chkper_ = parseFloat(
          Number(this.state.allpriceforTax_) * (Number(inputsprit) / 100)
        ).toFixed(2);
      } else {
        chkper_ = this.Discountinput.current.value;
      }
      this.Discount.current.value = chkper_;
      this.setState({ allpriceforTax_: this.state.allpriceforTax_ }); // เอาไว้ใช้คำนวนเบี้ยใหม่

      // this.Discount.current.value = parseFloat(Number(this.state.allpriceforTax_) * (Number(this.Discountinput.current.value) / 100)).toFixed(2);
      // this.setState({ allpriceforTax_: (Number(this.state.allpriceforTax_) + Number(this.state.deprositState)) });// เอาไว้ใช้คำนวนเบี้ยใหม่
    }
    setTimeout(() => {
      this._updateCalculatdi();
    }, 1000);
  };
  _updateCalculatdi = () => {
    if (this.state.PriceType_code === "0") {
      let sum1 = this.state.allpriceforTax_ - this.Discount.current.value;
      //  มูลค่าสินค่า
      this.ProductValue.current.value = parseFloat(sum1).toFixed(2);
      // ภาษีมูลค่าเพิ่ม
      this.TaxPrice.current.value = parseFloat((sum1 * 7) / 100).toFixed(2);
    } else if (this.state.PriceType_code === "1") {
      let sum2 =
        ((this.state.allpriceforTax_ - Number(this.Discount.current.value)) *
          100) /
        107;
      //  มูลค่าสินค่า
      this.ProductValue.current.value = parseFloat(sum2).toFixed(2);
      // ภาษีมูลค่าเพิ่ม
      this.TaxPrice.current.value = parseFloat(
        this.state.allpriceforTax_ -
        (Number(this.ProductValue.current.value) +
          Number(this.Discount.current.value))
      ).toFixed(2);
    } else if (this.state.PriceType_code === "2") {
      // console.log("this.state.allpriceforTax_"+this.state.allpriceforTax_);
      // ----------------------------------------------------------------------------------------------------- commm
      //มูลค่าสินค่า
      this.ProductValue.current.value = parseFloat(
        this.state.allpriceforTax_ - Number(this.Discount.current.value)
      ).toFixed(2);
      //ภาษีมูลค่าเพิ่ม
      this.TaxPrice.current.value = parseFloat(0).toFixed(2);
    }
    // this.ProductValue.current.value = Allprice - sum;
    // มูลค่ารวมภาษี
    this.valueTax.current.value = parseFloat(
      Number(this.ProductValue.current.value) + Number(this.TaxPrice.current.value)
    ).toFixed(2);
    // รวมเงินทั้งสิ้น
    this.TotalPrice.current.value = parseFloat(
      Number(this.ProductValue.current.value) + Number(this.TaxPrice.current.value)
    ).toFixed(2);
  };
  _calculatdiscountkey = (e) => {
    if (e.key === "Enter") {
      this._calculatdiscount();
    }
  };
  Get_warehouse = (data) => {
    this.CloseDialog(false)
    var DataValue = data.split("|");
    var Pr = this.state.products;
    var r = this.state.WHRow;
    //console.log(r, "sssss");
    Pr[r].warehouse = DataValue[0];
    Pr[r].location = DataValue[2];
    Pr[r].quantity = parseFloat(1).toFixed(2);
    setTimeout(() => {
      this.setState({ products: Pr });
      this.checkStkwarehouse(this.state.WHRow);
    }, 100);
  };
  // เช็คสต๊อค
  checkStkwarehouse = (row) => {
    var col = this.state.products;
    var urll =
      "CSSTKWAREHOUSE/checkstockqty?productcode=" +
      col[row].productcode +
      "&warehouse=" +
      this.state.productcodeinrow1 +
      "&location=" +
      col[row].location;
    var chki = 0;

    axios.get(genURL(urll), { timeout: 1800 }).then((res) => {
      //console.log(res);
      var chkloc = 0;
      for (var i = 0; i < res.data.length; i++) {
        chkloc = chkloc + 1;
        chki = chki + 1;
        /* col[row].location = res.data[i].LOCATION; */
        col[row].quantity = (1).toFixed(2);
      }
      setTimeout(() => {
        this.setState({ products: col });
      }, 100);
    })
      .then((_) => {
        setTimeout(() => {
          this.ReLoadData();
        }, 500);
      });
  };
  // Switch_PopUpwarehouse by dk
  Switch_PopUpwarehouse = (type) => {
    //console.log("case setwarehousetable");
    switch (type) {
      case "setwarehousetable":
        if (this.state.productcodeinrow !== "") {
          //ชื่อ
          this.setState({ typeFullScreenDialog: type })
          //open
          this.setState({ openFullScreenDialog: true })
          //title
          this.setState({ titleFullScreenDialog: "เลือกคลังและตำแหน่งเก็บ" })
        } else {
          this.setState({ opensnackbar: true })
          this.setState({ color: "warning" })
          this.setState({ icon: ErrorIcon })
          this.setState({ messagealert: "ไม่พบรหัสสินค้าในแถวที่ท่านเลือก" })
          return;
        }

        break;
    }
  };
  onClickTopbar = (e) => {
    console.log(e);
    switch (e) {
      case "save":
        this._connectsaveData()
        break;
      case "new":
        this.ResetThisPage()
        break;
      case "print":
        console.log("print");
        break;
      case "search":
        //ชื่อ
        this.setState({ typeFullScreenDialog: e })
        //open
        this.setState({ openFullScreenDialog: true })
        //title
        this.setState({ titleFullScreenDialog: "บันทึกใบสั่งขายสินค้า" })
        break;

      case "saleRef2":


        if (this.CustomerCode.current.value === "") {
          this.setState({ opensnackbar: true })
          this.setState({ color: "warning" })
          this.setState({ icon: ErrorIcon })
          this.setState({ messagealert: "กรุณากรอกรหัสลูกค้า" })
        } else {
          //ชื่อ
          this.setState({ typeFullScreenDialog: e })
          //open
          this.setState({ openFullScreenDialog: true })
          //title
          this.setState({ titleFullScreenDialog: "ค้นหาเอกสารอ้างอิงขาย-select" + e })
        }
        break;
      default:
        break;
    }
  }
  CloseDialog = (e) => {
    this.setState({ openFullScreenDialog: e })
  }

  resvalue = (data) => {
    console.log("resvaluedata", data);
    if (data.source === "CSWAREHOUSEALL") {
      this.setState({
        defaultwarehouse: data.warehouse,
        defaultlocation: data.location

      })
    }
  }

  reChecked = async (RowData) => {
    this.CloseDialog(false)
    this.setState({ openBackdrop: true })
    console.log("reChecked", RowData);
    await this.setRow(rowtable);
    this.setState({ _saveStatus: true });
    let url = "CSSALEORDER/Pageserachmain?code=" + RowData[0].docNo;
    await axios.get(genURL(url), { timeout: 12000 }).then((res) => {
      if (res.data) {
        for (let i = 0; i < res.data.length; i++) {
          if (res.data[i].ARCODE) {
            this.CustomerCode.current.value = res.data[i].ARCODE;
          }
          if (res.data[i].ARNAME) {
            this.CustomerName.current.value = res.data[i].ARNAME;
          }
          if (res.data[i].SHIPDATE = "null") {
            this.setState({ OrderDate: "" });
          }

          this.OrderNumber.current.value = res.data[i].DOCNO;
          this.onAddValue("Groupdata1", res.data[i].DOCGROUP, "Y").then((No) => {
            this.OrderNumber.current.value = res.data[i].DOCNO;
          });
          this.setState({ DOCGROUP_code: res.data[i].DOCGROUP });
          this.setState({ OrderDate: res.data[i].DOCDATE });
          this.Groupdata_code.current.value = res.data[i].DOCGROUP;

          this.CreditCode_code.current.value = res.data[i].CREDITCODE;
          this.CreditCode.current.value = CreditCode(res.data[i].CREDITCODE);
          this.REMARK.current.value = res.data[i].REMARK;
          this.onAddValue("Department", res.data[i].DEPARTMENT);
          this.setState({ Department_code: res.data[i].DEPARTMENT });
          this.onAddValue("Branch", res.data[i].SITECODE);
          this.setState({ Branch_code: res.data[i].SITECODE });
          this.UserFieldsname.current.value = res.data[i].Name;
          this.UserFieldslastname.current.value = res.data[i].LastName;
          this.UserFields3.current.value = res.data[i].registration;
          this.UserFields4.current.value = res.data[i].Price;
          this.UserFields5.current.value = res.data[i].inter;
          this.UserFields6.current.value = res.data[i].Rn_regist;
          this.onAddValue("SaleMan", res.data[i].SALECODE);
          /* this.SaleMan1.current.value = res.data[i].SALECODE; */
          this.onAddValue("CSAR", res.data[i].DEPARTMENT);

          this.TaxPersen.current.value = res.data[i].TAXRATE;
          this.TaxPrice.current.value = res.data[i].TAXAMOUNT;
          this.SumPrice.current.value = res.data[i].SUMAMOUNT1;
          this.ProductValue.current.value = res.data[i].AFTERDISC;
          this.Discountinput.current.value = res.data[i].DISCWORD;
          this.Discount.current.value = res.data[i].DISCAMOUNT;
          this.valueTax.current.value = res.data[i].TOTALAMOUNT;
          this.ValueExcept.current.value = res.data[i].SUMAMOUNT2;
          this.TotalPrice.current.value = res.data[i].BATHDEBTAMOUNT;
          this.setState({ _hprefix: res.data[i].PRE })
          let TAXTYPE = res.data[i].TAXTYPE;

          // console.log(TAXTYPE);
          setTimeout(() => {
            this._pricetype(TAXTYPE);
            try {
              this.ReLoadData();
            } catch (error) {
              console.log(error);
            }

          }, 50);
        }
      }
    });
    /* Pageserachsub */
    var urlsub = "CSSALEORDER/Pageserachsub?code=" + RowData[0].docNo;
    await axios.get(genURL(urlsub), { timeout: 12000 }).then(async res => {

      if (res.data.length > 0) {
        var data = this.state.products;
        for (var i = 0; i < res.data.length; i++) {
          let productgroup, productsubgroup
          if (res.data[i].PRODUCTSET !== 1) {
            let urlproduct = genURL("CSPRODUCT/Code?productset=" + res.data[i].PRODUCTSET + "&stocktype=" + res.data[i].STOCKTYPE + "&code=" + res.data[i].PRODUCTCODE)
            await axios.get(urlproduct, { timeout: 3600 }).then(async (result) => {
              if (result.data.length > 0) {
                productgroup = result.data[0].MAINGROUP == undefined ? "" : Number(result.data[0].MAINGROUP)
                productsubgroup = result.data[0].SUBGROUP1;
              }
            })
          }
          var unit = ""
          var date = res.data[0].DOCDATE.split('T')
          await checkunit(res.data[i].UNITNAME).then(data => { unit = data })
          data[i].productcode = res.data[i].PRODUCTCODE
          data[i].productname = res.data[i].PRODUCTNAME
          data[i].duedate = res.data[i].DOCDATE ? date[0] : "";
          data[i].DeliDate = ReDate(res.data[i].SHIPDATE)
          data[i].warehouse = res.data[i].SITECODE
          data[i].location = res.data[i].LOCATION
          data[i].unitcode = res.data[i].UNITCODE
          data[i].unitname = unit
          data[i].quantity = res.data[i].QUANTITY
          data[i].saleprice = res.data[i].AMOUNT
          data[i].discountword = res.data[i].DISCAMOUNT
          data[i].amount = res.data[i].UNITPRICE
          data[i].refer = res.data[i].REFDOCNO1
          data[i].productgroup = productgroup
          data[i].productsubgroup = productsubgroup
          data[i].stocktype = res.data[i].STOCKTYPE
          data[i].productset = res.data[i].PRODUCTSET
          data[i].parentcode = res.data[i].PARENTCODE

          //console.log(i, res.data.length);
          if (i === res.data.length - 1) {
            await this.setState({ products: data })
            await this.Cal_Price()

          }
        }
      }
    });

    await this.setState({ openBackdrop: false })

  }
  selectSaleref = async (e) => {
    await this.setState({ openFullScreenDialog: false })
    // console.log("selectSaleref", e)
    if (e.length > 0) {
      for (let index = 0; index < e.length; index++) {
        // console.log("selectSaleref", e[index].docNo) 
        var data = this.state.products;
        let productgroup, productsubgroup
        if (e[index].productSet !== 1) {
          let urlproduct = genURL("CSPRODUCT/Code?productset=" + e[index].productSet + "&stocktype=" + e[index].stockType + "&code=" + e[index].productCode)
          await axios.get(urlproduct, { timeout: 3600 }).then(async (result) => {
            if (result.data.length > 0) {
              productgroup = result.data[0].MAINGROUP == undefined ? "" : Number(result.data[0].MAINGROUP)
              productsubgroup = result.data[0].SUBGROUP1;
            }
          })
        }
        data[index].productcode = e[index].productCode
        data[index].productname = e[index].productName
        data[index].duedate = e[index].grDateX;
        data[index].DeliDate = ReDate(e[index].grDateX)
        data[index].warehouse = e[index].warehouse
        data[index].location = e[index].location
        data[index].unitcode = e[index].unitCode
        data[index].unitname = e[index].unitName
        data[index].quantity = e[index].quantity
        data[index].saleprice = e[index].price
        data[index].discountword = e[index].discWord
        data[index].amount = Number(e[index].quantity) * Number(e[index].price) - Number(e[index].discWord)
        data[index].refer = e[index].refdocno
        data[index].productgroup = productgroup
        data[index].productsubgroup = productsubgroup
        data[index].stocktype = e[index].stockType
        data[index].productset = e[index].productSet
        data[index].parentcode = typeof e[index].PARENTCODE !== "undefined" ? e[index].PARENTCODE : ""
        await this.setState({ products: data })
      }
    } else {
      await setState((prevState) => ({ ...prevState, rows: [], openbackdrop: false }))
    }

    await this.Cal_Price()
  }
  render() {
    const type = this.state.typeFullScreenDialog
    return (
      <div className="PSApp" onBlur={this.onBlur}>
        <Backdrop open={this.state.openBackdrop} />
        <FullScreenDialog open={this.state.openFullScreenDialog} title={this.state.titleFullScreenDialog} closeDialog={e => this.CloseDialog(e)}>
          {type === "Groupdata" || type === "Department" || type === "Branch" || type === "CreditCode" ? <PopUpOther closePopup={e => this.CloseDialog(e)} type={this.state.OtPopupType} Get_PopUpOther={this.Get_PopUpOther} from="CSSALEORDER" userSite={this.state.siteCodeUser} /> : null}
          {type === "Search_Table" ? <PopUpItem closePopup={e => this.CloseDialog(e)} Get_PopUpItem={this.Get_PopUpItem} userSite={this.state.siteCodeUser} /> : null}
          {type === "Search_ARCode" ? <PopupArcode closePopup={e => this.CloseDialog(e)} Get_PopUparcode={this.Get_PopUparcode} /> : null}
          {type === "setwarehousetable" ? <PopUpwarehouse closePopup={e => this.CloseDialog(e)} type="setdefaultwarehouse" Get_PopUpOther={this.Get_warehouse} productcodeinrow={this.state.productcodeinrow} productcodeinrow1={this.state.productcodeinrow1} from="CSSALEORDER" /> : null}
          {type === "search" ? <Rechecked Dataselect={this.reChecked} from="CSSALEORDER" /> : null}
          {type === "Report" ? <Repostview url={this.state.urlsend} /> : null}

          {type === "saleRef2" ? <Selectsaleref2
            arCode={this.CustomerCode.current.value}
            Dataselect={e => this.selectSaleref(e)}
            from={"saleRef2"} /> : null}
        </FullScreenDialog>
        <Topbar
          listmenu={listmenu}
          title="บันทึกใบสั่งขายสินค้า"
          onClick={e => this.onClickTopbar(e)}
        />
        <div className="PSAppfrom">
          <Grid>
            <Col xs={12} sm={12} md={12} lg={12}>
              <Row className="show-grid">
                <Col xs={12} sm={4} md={4} lg={4}>
                  <Row className="show-grid">
                    <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                      <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <span className="input-group-addon">รหัสลูกค้า </span>
                        <input type="text" className="form-control" name="CustomerCode" ref={this.CustomerCode} tabIndex={1}
                          onKeyDown={this.Get_Arcode}
                          onChange={this.Onblur} />
                        <span className="input-group-addon icon" onClick={() => this.Switch_PopupArcode("Search_ARCode")} >
                          <i > <ArrowDropDownRoundedIcon fontSize="small" /></i>
                        </span>
                      </div>
                    </div>
                  </Row>
                </Col>
                <Col xs={12} sm={4} md={4} lg={4}>
                  <Row className="show-grid">
                    <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                      <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <span className="input-group-addon icon">
                          <i className="fas fa-user"></i>
                        </span>
                        <input type="text" className="form-control" disabled ref={this.CustomerName} />
                        {/* <span id="iconTaxNumber" className="input-group-addon icon">
                          <i ></i>
                        </span> */}
                      </div>
                    </div>
                  </Row>
                </Col>
                <Col xs={12} sm={4} md={4} lg={4}>
                  <Row className="show-grid">
                    <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                      <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <span className="input-group-addon">เลขที่ใบสั่งขาย</span>
                        <input type="text" className="form-control" ref={this.OrderNumber} readOnly={this.state.OpenTAXNO} />
                        {/* <span id="iconTaxNumber" className="input-group-addon icon">
                          <i className="fab fa-expeditedssl" ></i>
                        </span> */}
                      </div>
                    </div>
                  </Row>
                </Col>
                <Col xs={12} sm={4} md={4} lg={4}>
                  <Row className="show-grid">
                    <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                      <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <span className="input-group-addon">กลุ่มข้อมูล </span>
                        <input type="text" className="form-control hidden" ref={this.Groupdata_code} />
                        <input type="text" className="form-control" name="Groupdata" ref={this.Groupdata} tabIndex={2} onClick={this.ClickDocGroupcode} onKeyDown={this.onKeyPress} onChange={this.Onblur} />
                        <span id="iconGroupdata" className="input-group-addon icon" onClick={this.Switch_OtherPopup.bind(null, "Groupdata")}>
                          <i > <ArrowDropDownRoundedIcon fontSize="small" /></i>
                        </span>
                      </div>
                    </div>
                  </Row>
                </Col>
                <Col xs={12} sm={4} md={4} lg={4}>
                  <Row className="show-grid">
                    <MaterialUIPickers title="วันที่สั่งขาย"
                      DateValue={e => this.SelectSetData("Calendar", e)}
                      defaultdate={this.state.OrderDate}
                      open={this.state.checkenableInput["DOCDATE"]} />
                  </Row>
                </Col>
                <Col xs={12} sm={4} md={4} lg={4}>
                  <Row className="show-grid">
                    <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                      <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <SelectDatas
                          origin="PriceType"  // ประเภท
                          valueSelect={e => this.SelectSetData("PriceType", e)} // รับค่ากลับ
                          title="ประเภทราคา"
                          defaultselect={this.state.defaultselect}// ค่าเริ่มต้นของ ประเภทราคา
                        />
                      </div>
                    </div>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Grid>
          <Grid>
            <Col xs={12} sm={12} md={12} lg={12}>
              <Row className="show-grid">
                <Col xs={12} sm={4} md={4} lg={4}>
                  <Row className="show-grid">
                    <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                      <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <span className="input-group-addon">รหัสเครดิต</span>
                        <input type="text" className="form-control hidden" ref={this.CreditCode_code} />
                        <input type="text" className="form-control" ref={this.CreditCode} onKeyPress={this.onChangeData.bind(null, "CreditCode")} onBlur={this.SwitchValue.bind(null, "CreditCode", "OUT")} onClick={this.SwitchValue.bind(null, "CreditCode", "IN")} disabled />
                        <span id="iconCreditCode" className="input-group-addon icon" onClick={this.Switch_OtherPopup.bind(null, "CreditCode")}>
                          <i > <ArrowDropDownRoundedIcon fontSize="small" /></i>
                        </span>
                      </div>
                    </div>
                  </Row>
                </Col>
                <Col xs={12} sm={4} md={4} lg={4}>
                  <Row className="show-grid">
                    <MaterialUIPickers title="นัดส่งมอบ"
                      DateValue={e => this.SelectSetData("Calendar1", e)}
                      defaultdate={this.state.OrderDate1} />
                  </Row>
                </Col>
              </Row>
            </Col>
            <Col xs={12} sm={6} md={6} lg={6}>
              <Row className="show-grid">
                <CustomInput title="คลังเริ่มต้น" value={this.state.defaultvaluewarehouse} disabledvalue={true} of_title={false} of_btn={false}
                  source={"CSWAREHOUSEALL"}
                  propsvalue={this.resvalue}
                />
              </Row>
            </Col>

          </Grid>
        </div>
        <div className="container-fluid">
          <div >
            <Modal show={this.state.show1} size="sm" /* onHide={true}  */ >
              <ModalHeader style={{ borderRadius: '10px 10px 0px 0px' }}>
                <div className="PopUpOtherDivH1"><i className="fas " style={{ color: 'black' }}> ปรับราคา </i></div>
                <div className="PopUpOtherDivH2"><i className="fas fa-times" style={{ color: 'white' }} onClick={() => { this.setState({ show1: false }) }}></i></div>
              </ModalHeader>
              <ModalBody style={{ fontSize: '20px', left: '12px' }}>ต้องการปรับราคาขายต่อหน่วยใหม่หรือไม่! </ModalBody>
              <ModalFooter style={{ borderRadius: '0px 0px 10px 10px' }}>
                <Button variant="secondary" style={{ width: '60px', height: '36px', fontSize: '20px' }} onClick={e => { this.AddDataTable2(); this.setState({ show1: false }) }}> ใช่ </Button>
                <Button variant="primary" style={{ width: '60px', height: '36px', fontSize: '20px' }} onClick={e => { this.setState({ show1: false }) }}> ไม่ใช่ </Button>
              </ModalFooter>
            </Modal>
          </div>
          <div className=" PSAppTable">
            {/* หมายเหตุ 
            1 การเพิ่มฟิวล์ข้อมูลในตารางให้เพิ่มต่อท้ายเสมอ
            2 ห้ามย้ายตำแหน่ง ของฟิวล์เด็ดขาด */}
            <BootstrapTable
              data={this.state.products}
              trClassName="trClassName"
              tableHeaderclassName="trClassName"
              options={{ noDataText: "...", onRowClick: this.onRowClick, }}
              cellEdit={{
                //แก้ไข
                mode: "click",
                blurToSave: true,
                beforeSaveCell: this.onBeforeSaveCell,
                afterSaveCell: this.onAfterSaveCell,
              }}
              // ไม่ให้พิมพ์ข้อมูลได้
              // keyBoardNav={{ enterToEdit: true }}
              height="400"
            >
              <TableHeaderColumn row="0" rowSpan="2" dataField="C0" isKey width="35px" dataAlign="center" dataFormat={this._chkload.bind(this)}></TableHeaderColumn>
              <TableHeaderColumn row="0" colSpan="2" dataAlign="center" width="150" className="colbuttomhidden"> รหัสสินค้า</TableHeaderColumn>
              <TableHeaderColumn row="1" dataField="productcode" editable={this.state.col1} dataAlign="left" width="120">    <div align="center"></div></TableHeaderColumn>
              <TableHeaderColumn row="1" dataField="Btn1" editable={false} dataAlign="left" width="30" dataFormat={this._cellButton.bind(this)} columnClassName="columnClassNameFormat1">  <i id="TableLoadItem" style={{ fontSize: "10px" }}></i></TableHeaderColumn>
              <TableHeaderColumn row="0" rowSpan="2" dataField="productname" editable={false} dataAlign="left" width="140">  <div align="center">ชื่อสินค้า</div></TableHeaderColumn>
              <TableHeaderColumn row="0" rowSpan="2" dataField='duedate' width="180" editable={{ type: 'date' }} dataAlign="center">นัดส่งมอบ</TableHeaderColumn>
              <TableHeaderColumn row="0" colSpan="2" dataAlign="center" width="120" className="colbuttomhidden">คลัง</TableHeaderColumn>
              <TableHeaderColumn row="1" dataField="warehouse" editable={this.state.col} dataAlign="center" width="90"></TableHeaderColumn>
              <TableHeaderColumn row="1" dataField="btn_warehouse" editable={false} dataAlign="center" width="30" dataFormat={this._cellButton_btn_DeliDate.bind(this)} columnClassName="columnClassNameFormat1">  <i id="TableLoadItem" style={{ fontSize: "10px" }}></i></TableHeaderColumn>
              <TableHeaderColumn row="0" colSpan="2" dataAlign="center" width="120" className="colbuttomhidden">  ตำแหน่งเก็บ</TableHeaderColumn>
              <TableHeaderColumn row="1" dataField="location" editable={this.state.col} dataAlign="center" width="90">  </TableHeaderColumn>
              <TableHeaderColumn row="1" dataField="btn_location" editable={false} dataAlign="center" width="30" dataFormat={this._cellButton_btn_DeliDate1.bind(this)} columnClassName="columnClassNameFormat1"></TableHeaderColumn>
              <TableHeaderColumn row="0" rowSpan="2" dataField="unitname" editable={false} dataAlign="center" width="90">หน่วย</TableHeaderColumn>
              <TableHeaderColumn row="0" rowSpan="2" dataField="quantity" editable={this.state.col} dataAlign="center" width="90">ปริมาณ</TableHeaderColumn>
              <TableHeaderColumn row="0" rowSpan="2" dataField="saleprice" editable={this.state.col && this.state.checkenableInput['UNITPRICE'] > 0} dataAlign="right" width="90">ราคาขาย</TableHeaderColumn>
              <TableHeaderColumn row="0" rowSpan="2" dataField="discountword" editable={this.state.col} dataAlign="right" width="90">ลด</TableHeaderColumn>
              <TableHeaderColumn row="0" rowSpan="2" dataField="discountamount" editable={false} dataAlign="right" width="90">จำนวนเงิน(ส่วนลด)</TableHeaderColumn>
              <TableHeaderColumn row="0" rowSpan="2" dataField="amount" editable={false} dataAlign="right" width="90"><div align="center"> จำนวนเงิน </div></TableHeaderColumn>
              <TableHeaderColumn row="0" rowSpan="2" dataField="refer" editable={false} dataAlign="right" width="90"><div align="center"> อ้างอิง </div></TableHeaderColumn>
              <TableHeaderColumn row="0" rowSpan="2" dataField="unitcode" editable={false} width="90" hidden  > unitcode </TableHeaderColumn>
              <TableHeaderColumn row="0" rowSpan="2" dataField="productgroup" editable={false} dataAlign="right" width="90" hidden ><div align="center"> productgroup </div></TableHeaderColumn>
              <TableHeaderColumn row="0" rowSpan="2" dataField="productsubgroup" editable={false} dataAlign="right" width="90" hidden  ><div align="center"> productsubgroup </div></TableHeaderColumn>
              <TableHeaderColumn row="0" rowSpan="2" dataField="stocktype" width="90" editable={false} hidden >stocktype</TableHeaderColumn>
              <TableHeaderColumn row="0" rowSpan="2" dataField="productset" width="90" editable={false} hidden  >productset</TableHeaderColumn>
              <TableHeaderColumn row="0"
                rowSpan="2"
                dataField="parentcode" width="90" editable={false} hidden>parentcode</TableHeaderColumn>
            </BootstrapTable >
          </div >
          <div className="PSAppfrom">
            <Grid>
              <Col xs={12} sm={8} md={8} lg={8}>
                <Row className="show-grid">
                  {/*  col ที่ 1 */}
                  <Col xs={12} sm={6} md={6} lg={6}>
                    <div className="row">
                      <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                          <span className="input-group-addon">พนักงานขาย</span>
                          <input type="text" className="form-control hidden" ref={this.SaleMan_code} />
                          <input type="text" className="form-control" ref={this.SaleMan} disabled />
                          <span id=" " className="input-group-addon icon">
                            <i className="fas fa-sync-alt" onClick={() => this.onAddValue("Csuser", this.state.siteCodeUser1)}></i>
                          </span>
                        </div>
                      </div>
                      <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12" >
                        <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12" >
                          <span className="input-group-addon">แผนก   </span>
                          <input type="text" className="form-control hidden" ref={this.Department_code} />
                          <input   /* id="id1" */ type="text" className="form-control " name="Department" ref={this.Department} tabIndex={4}
                            onClick={this.ClickDepartmentCode} onKeyDown={this.onKeyPress} onChange={this.Onblur}
                          />
                          <span id="CSDEPARTMENT" className="input-group-addon icon" onClick={this.Switch_OtherPopup.bind(null, "Department")}>
                            <i > <ArrowDropDownRoundedIcon fontSize="small" /></i>
                          </span>
                        </div>
                      </div>
                      <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12" >
                        <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12" >
                          <SelectDatas
                            origin="PROJECT"  // โครงการ
                            valueSelect={e => this.SelectSetData("PROJECT", e)} // รับค่ากลับ
                            title="โครงการ"
                            defaultselect={this.state.PROJECT}// ค่าเริ่มต้นของ โครงการ
                          />
                        </div>
                      </div>

                    </div>
                  </Col>
                  {/*  col ที่ 1.2 */}
                  <Col xs={12} sm={6} md={6} lg={6}>
                    <div className="row">
                      <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12" >
                        <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                          <span className="input-group-addon">  สาขา  </span>
                          <input type="text" className="form-control hidden" ref={this.Branch_code} />
                          <input  /* id="id1" */ type="text" className="form-control" name="SiteCode" ref={this.Branch} tabIndex={5}
                            onClick={this.ClickSiteCode} onKeyDown={this.onKeyPress} onChange={this.Onblur}
                          />
                          <span id="iconBranch" className="input-group-addon icon" onClick={this.Switch_OtherPopup.bind(null, "Branch")}>
                            <i > <ArrowDropDownRoundedIcon fontSize="small" /></i>
                          </span>
                        </div>
                      </div>

                      <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                          <span className="input-group-addon">สกุลเงิน   </span>
                          <input type="text" className="form-control" ref={this.pricetype} defaultValue="บาท" />
                          <span className="input-group-addon icon" >
                            <i ></i>
                          </span>
                        </div>
                      </div>
                      <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                          <span className="input-group-addon">อัตราแลกเปลี่ยน  </span>
                          <input type="text" className="form-control Price" defaultValue="1.0000000" />
                          {/* <span className="input-group-addon icon"></span> */}
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row className="show-grid">
                  {/*  col ที่ 1 */}
                  <Col xs={12} sm={12} md={12} lg={12}>
                    <Row className="show-grid">
                      <Col xs={12} sm={12} md={12} lg={12}>
                        <div className="row">
                          <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                            <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                              <span className="input-group-addon">หมายเหตุ</span>
                              <input type="text" className="form-control" ref={this.REMARK} tabIndex={5} />
                              {/* <span className="input-group-addon icon"></span> */}
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
              {/*  col ที่ 2 */}
              <Col xs={12} sm={4} md={4} lg={4} >
                <Row className="show-grid">
                  <Col xs={12} sm={12} md={12} lg={12}>
                    <div className="row ">
                      <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                          <span className="input-group-addon">รวมจำนวนเงิน</span>
                          <input type="" className="form-control Price" ref={this.SumPrice} disabled />
                        </div>
                      </div>
                      <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12"  >
                        <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                          <span className="input-group-addon">ส่วนลด</span>
                          <input type="text" className="form-control Price" ref={this.Discountinput}
                            onClick={(e) => { e.target.value = parseFloat(e.target.value).toFixed(0); }}
                            onKeyDown={this.Cal_Price1}
                            onBlur={this.Cal_Price.bind(null)}
                          /* onBlur={this._calculatdiscount} */
                          /* onKeyPress={this._calculatdiscountkey} */
                          />
                          <span className="input-group-addon icon">  <i className="fas fa-percentage"></i></span>
                          <input type="text" className="form-control Price" ref={this.Discount} disabled />
                        </div>
                      </div>

                      <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                          <span className="input-group-addon">มูลค่าสินค้า</span>
                          <input type="text" className="form-control Price" ref={this.ProductValue} disabled />
                          {/* <span className="input-group-addon icon" onClick={this.Cal_Price.bind(null)} > */}
                          {/* <i  className="fas fa-calculator" ></i> */}
                          {/* </span> */}
                        </div>
                      </div>

                      <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                          <span className="input-group-addon">ภาษีมูลค่าเพิ่ม</span>
                          <input type="text" className="form-control Price" ref={this.TaxPersen}
                            onClick={(e) => { e.target.value = parseFloat(e.target.value).toFixed(0); }}
                            onKeyDown={this.Cal_Price1}
                            onBlur={this.Cal_Price.bind(null)}
                          />
                          <span className="input-group-addon icon">  <i className="fas fa-percentage"></i></span>
                          <input type="text" className="form-control Price" ref={this.TaxPrice} disabled />
                          {/* <span className="input-group-addon icon" onClick={this.Cal_Price.bind(null)}>
                            <i  className="fas fa-calculator" ></i>
                          </span> */}
                        </div>
                      </div>

                      <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12" >
                        <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                          <span className="input-group-addon ">มูลค่ารวมภาษี</span>
                          <input type="text" className="form-control Price" ref={this.valueTax} disabled />
                          {/* <span className="input-group-addon icon"   onClick={this.Cal_Price.bind(null)}  >
                            <i   className="fas fa-calculator"  ></i>
                          </span> */}
                        </div>
                      </div>

                      <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12" >
                        <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                          <span className="input-group-addon"> มูลค่ายกเว้น</span>
                          <input type="text" className="form-control Price" ref={this.ValueExcept} disabled />
                          {/* {/* <span className="input-group-addon icon"   onClick={this.Cal_Price.bind(null)}  >  }
                            <i  className="fas fa-calculator"  ></i>
                          </span> */}
                        </div>
                      </div>
                      <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12"  >
                        <div className="input-group  col-xs-12 col-sm-12 col-lg-12 col-md-12">
                          <span className="input-group-addon"> รวมเงินทั้งสิ้น</span>
                          <input type="text" className="form-control Price" ref={this.TotalPrice} disabled />
                          {/* <span className="input-group-addon icon"   onClick={this.Cal_Price.bind(null)}>
                            <i className="fas fa-calculator"></i>
                          </span> */}
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col xs={12} sm={12} md={12} lg={12}>
                <Row className="show-grid">
                  <Col xs={12} sm={12} md={12} lg={12}>
                    <Panel>
                      <Panel.Heading>
                        <Panel.Title componentclass="h5">ข้อมูลเพิ่มเติม ( User's Field) </Panel.Title>
                      </Panel.Heading>
                      <Panel.Body>
                        <Col xs={12} sm={12} md={12} lg={12} >
                          <Row className="show-grid">
                            {/* <Col xs={12} sm={12} md={3} lg={4}>
                              <SelectDatas
                                origin="_prefix"  // ประเภท
                                valueSelect={e => this.SelectSetData("_prefix", e)} // รับค่ากลับ
                                title="คำนำหน้า"
                                defaultselect={this.state._hprefix}// ค่าเริ่มต้นของ ประเภทราคา
                              />
                            </Col> */}
                            <Col xs={12} sm={12} md={3} lg={4}>
                              <div className="row">
                                <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                  <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                    <span className="input-group-addon"> ชื่อ</span>
                                    <input type="text" className="form-control " ref={this.UserFieldsname} tabIndex={6} />
                                  </div>
                                </div>
                              </div>
                            </Col>
                            <Col xs={12} sm={12} md={3} lg={4}>
                              <div className="row">
                                <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                  <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                    <span className="input-group-addon"> นามสกุล</span>
                                    <input type="text" className="form-control " ref={this.UserFieldslastname} tabIndex={7} />
                                  </div>
                                </div>
                              </div>
                            </Col>

                            <Col xs={12} sm={12} md={3} lg={4}>
                              <div className="row">
                                <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                  <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                    <span className="input-group-addon "> ค่างวด</span>
                                    <input type="text" className="form-control Price" ref={this.UserFields3} tabIndex={8} />
                                  </div>
                                </div>
                              </div>
                            </Col>

                          </Row>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={12} >
                          <Row className="show-grid">


                            <Col xs={12} sm={12} md={3} lg={4}>
                              <div className="row">
                                <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                  <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                    <span className="input-group-addon "> ราคารวมผ่อน</span>
                                    <input type="text" className="form-control Price" ref={this.UserFields4} tabIndex={9} />
                                  </div>
                                </div>
                              </div>
                            </Col>


                            <Col xs={12} sm={12} md={3} lg={4}>
                              <div className="row">
                                <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                  <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                    <span className="input-group-addon "> ดอกเบี้ย</span>
                                    <input type="text" className="form-control Price" ref={this.UserFields5} tabIndex={10} />
                                  </div>
                                </div>
                              </div>
                            </Col>
                            <Col xs={12} sm={12} md={3} lg={4}>
                              <div className="row">
                                <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                  <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                    <span className="input-group-addon "> ทะเบียน รีนิว</span>
                                    <input type="text" className="form-control " ref={this.UserFields6} tabIndex={11} />
                                  </div>
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </Col>
                      </Panel.Body>
                    </Panel>
                  </Col>
                </Row>
              </Col>
            </Grid>

            <Snackbar place="br"
              color={this.state.color}
              icon={this.state.icon}
              autoClose={this.state.autoClose}
              message={this.state.messagealert}
              open={this.state.opensnackbar}
              closeNotification={() => { this.setState({ opensnackbar: false }) }}
              close />
          </div>
        </div >
      </div >

    );
  }
}
